export const CUSTOMER_GROUP = {
	FRANCHISE: 'franchise',
	MEMBER: 'member',
};
